import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { HomeService } from 'src/home/home.service';
import { NewPasswordUser } from 'src/models/newPasswordUser.interface';
import Swal from 'sweetalert2';
import { UsersService } from '../services/users.service';


@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.css']
})

export class ChangePasswordModalComponent implements OnInit {
  @Output() passwordChanged = new EventEmitter<void>();

  newPasswordUser: NewPasswordUser = {
    password: '',
    email_user_to_change: this.data.email
  };

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    private usersService: UsersService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  // openUserFormModal(): void {
  //   const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
  //     width: '70%',
  //     maxWidth: '600px',
  //     data: { title: 'Usuario' }
  //   });

  //   dialogRef.afterClosed().subscribe((result: NewPasswordUser) => {
  //     if (result) {
  //       this.handleChangePassword(result);
  //     }
  //   });
  // }



  // handleChangePassword(newPasswordUser: NewPasswordUser): void {

  //   if (!newPasswordUser || !newPasswordUser.password) {
  //     Swal.fire({
  //       text: 'Por favor, completa todos los campos.',
  //       icon: 'warning',
  //       confirmButtonText: 'OK',
  //       confirmButtonColor: '#3085d6'
  //     });
  //     return;
  //   }


  //   const formattedNewPasswordUser: NewPasswordUser = { password: newPasswordUser.password, email_user_to_change: newPasswordUser.email_user_to_change };

  //   this.usersService.changePassword(formattedNewPasswordUser as any).subscribe(() => {

  //     Swal.fire({
  //       text: 'La contraseña se ha cambiado correctamente.',
  //       icon: 'success',
  //       confirmButtonText: 'OK',
  //       confirmButtonColor: '#4caf50'
  //     });

  //     localStorage.setItem('userPassword', newPasswordUser.password);
  //     this.dialogRef.close('passwordChanged');
  //     this.passwordChanged.emit();
  //   }, (error) => {

  //     Swal.fire({
  //       text: 'Error al cambiar la contraseña. Por favor, inténtalo de nuevo más tarde.',
  //       icon: 'error',
  //       confirmButtonText: 'OK',
  //       confirmButtonColor: '#d33'
  //     });
  //     console.error('Error al cambiar la contraseña:', error);

  //   })

  // }


  // closeModal(): void {
  //   this.dialogRef.close();
  // }

  // isFormValid(): boolean {
  //   return this.newPasswordUser.password.trim() !== '' && this.newPasswordUser.email_user_to_change!.trim() !== '';
  // }

  handleChangePassword(newPasswordUser: NewPasswordUser): void {
    if (!newPasswordUser || !newPasswordUser.password) {
      Swal.fire({
        text: 'Por favor, completa todos los campos.',
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6'
      });
      return;
    }

    const formattedNewPasswordUser: NewPasswordUser = { password: newPasswordUser.password, email_user_to_change: newPasswordUser.email_user_to_change };

    this.usersService.changePassword(formattedNewPasswordUser as any).subscribe(() => {
      Swal.fire({
        text: 'La contraseña se ha cambiado correctamente.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#4caf50'
      });

      localStorage.setItem('userPassword', newPasswordUser.password);
      this.dialogRef.close('passwordChanged');
      this.passwordChanged.emit();
    }, (error) => {
      Swal.fire({
        text: 'Error al cambiar la contraseña. Por favor, inténtalo de nuevo más tarde.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33'
      });
      console.error('Error al cambiar la contraseña:', error);
    })
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  isFormValid(): boolean {
    return this.newPasswordUser.password.trim() !== '' && this.newPasswordUser.email_user_to_change!.trim() !== '';
  }
}




